import Vue from "vue";
import Router from "vue-router";
import BaseRouter from "views/common/base-router.vue";
import layout from "views/layout/index";

Vue.use(Router);

const routes = [
    {
        path: "/",
        name: "layout",
        component: resolve => require(["../views/layout/index.vue"], resolve),
        redirect: "/Login",
        children: [
            {
                path: "/business/busPla",
                name: "商务管理",
                component: resolve =>
                    require(["../views/business/index.vue"], resolve),
                meta: {
                    title: "商务管理"
                }
            },
            {
                path: "/business/tos",
                name: "客户委托",
                component: resolve =>
                    require(["../views/business/tos/index"], resolve),
                meta: {
                    title: "客户委托"
                }
            },
            {
                path: "/business/tos/reportWzg",
                name: "生产日报（万州港）",
                component: resolve =>
                    require(["../views/business/tos/reportWzg"], resolve),
                meta: {
                    title: "生产日报（万州港）"
                }
            },
            {
                path: "/business/tos/reportWjs",
                name: "生产日报（万九司）",
                component: resolve =>
                    require(["../views/business/tos/reportWjs"], resolve),
                meta: {
                    title: "生产日报（万九司）"
                }
            },
            {
                path: "/first",
                name: "欢迎",
                component: resolve =>
                    require(["../views/business/first.vue"], resolve),
                meta: {
                    title: "欢迎"
                }
            },
            {
                path: "/business/busPla/Customer",
                name: "客户管理",
                component: resolve =>
                    require(["../views/business/customer/index.vue"], resolve),
                meta: {
                    title: "客户管理"
                }
            },
            {
                path: '/business/busPla/CustomerLogin',
                name: '客户登录账号',
                component: resolve => require(['../views/business/customer/indexLogin.vue'], resolve),
                meta: {
                    title: '客户登录账号'
                }
            },
            {
                path: '/business/busPla/Contract',
                name: '合同管理',
                component: resolve => require(['../views/business/contract/index.vue'], resolve),
                meta: {
                    title: "合同管理"
                }
            },
            {
                path: "/business/busPla/Track",
                name: "集装箱追踪查询",
                component: resolve =>
                    require([
                        "../views/business/containerTrack/containerTrack.vue"
                    ], resolve),
                meta: {
                    title: "集装箱追踪查询"
                }
            },
            {
                path: "/business/busPla/ContainerOnPort",
                name: "在港箱查询",
                component: resolve =>
                    require([
                        "../views/business/ContainerOnPort/ContainerOnPort.vue"
                    ], resolve),
                meta: {
                    title: "在港箱查询"
                }
            },
            {
                path: "/business/busPla/Entrust",
                name: "委托管理",
                component: resolve =>
                    require(["../views/business/entrust/index.vue"], resolve),
                meta: {
                    title: "委托管理"
                }
            },
            {
                path: "/Home/SystemS",
                name: "系统管理工作台",
                component: resolve =>
                    require(["../views/business/system/index.vue"], resolve),
                meta: {
                    title: "系统管理工作台"
                }
            },
            {
                path: "/Home/SystemBase",
                name: "基础管理工作台",
                component: resolve =>
                    require(["../views/business/jobBase/index.vue"], resolve),
                meta: {
                    title: "基础管理工作台"
                }
            },
            {
                path: "/Home/ruleBase",
                name: "规则配置",
                component: resolve =>
                    require(["../views/business/ruleDispose/index.vue"], resolve),
                meta: {
                    title: "规则配置"
                }
            },
            {
                path: "/Home/SystemBase/Port",
                name: "港口管理",
                component: resolve =>
                    require(["../views/business/port/port.vue"], resolve),
                meta: {
                    title: "港口管理"
                }
            },
            {
                path: "/Home/SystemBase/EntrustSplitRule",
                name: "委托拆分计划规则",
                component: resolve =>
                    require([
                        "../views/business/entrustSplitRule/index.vue"
                    ], resolve),
                meta: {
                    title: "委托拆分计划规则"
                }
            },
            /*{
                path: "/Home/SystemBase/processRule",
                name: "流程配置规则",
                component: resolve =>
                    require([
                        "../views/business/processRule/index.vue"
                    ], resolve),
                meta: {
                    title: "流程配置规则"
                }
            },*/
            {
                path: "/Home/SystemBase/ContainerType",
                name: "箱类型管理",
                component: resolve =>
                    require([
                        "../views/business/containerType/index.vue"
                    ], resolve),
                meta: {
                    title: "箱类型管理"
                }
            },
            {
                path: "/Home/SystemBase/ContainerType",
                name: "箱类型管理",
                component: resolve =>
                    require([
                        "../views/business/containerType/index.vue"
                    ], resolve),
                meta: {
                    title: "箱类型管理"
                }
            },
            {
                path: "/Home/SystemBase/ContainerSize",
                name: "箱尺寸管理",
                component: resolve =>
                    require([
                        "../views/business/containerSize/index.vue"
                    ], resolve),
                meta: {
                    title: "箱尺寸管理"
                }
            },
            {
                path: "/Home/SystemBase/jobWorkTeam",
                name: "作业班组管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/jobWorkTeam.vue"
                    ], resolve),
                meta: {
                    title: "作业班组管理"
                }
            },
            {
                path: "/Home/SystemBase/jobProfession",
                name: "作业工种管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/jobProfession.vue"
                    ], resolve),
                meta: {
                    title: "作业工种管理"
                }
            },
            {
                path: "/Home/SystemBase/operator",
                name: "作业人员管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/operator.vue"
                    ], resolve),
                meta: {
                    title: "作业人员管理"
                }
            },
            {
                path: "/Home/SystemBase/jobTerminal",
                name: "终端管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/jobTerminal.vue"
                    ], resolve),
                meta: {
                    title: "终端管理"
                }
            },
            {
                path: "/Home/SystemBase/jobMachinery",
                name: "机械管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/jobMachinery.vue"
                    ], resolve),
                meta: {
                    title: "机械管理"
                }
            },
            {
                path: "/Home/SystemBase/jobVehicle",
                name: "车辆管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/jobVehicle.vue"
                    ], resolve),
                meta: {
                    title: "车辆管理"
                }
            },
            {
                path: "/Home/SystemBase/specialTransportLine",
                name: "专运线管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/specialTransportLine.vue"
                    ], resolve),
                meta: {
                    title: "专运线管理"
                }
            },
            {
                path: "/Home/SystemBase/specialTransportLineMachine",
                name: "专运线机械配置",
                component: resolve =>
                    require([
                        "../views/business/baseResource/specialTransportLineMachine.vue"
                    ], resolve),
                meta: {
                    title: "专运线机械配置"
                }
            },
            {
                path: "/Home/SystemBase/cargoType",
                name: "货类管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/cargoType.vue"
                    ], resolve),
                meta: {
                    title: "货类管理"
                }
            },
            {
                path: "/Home/SystemBase/cargoName",
                name: "品名管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/cargoName.vue"
                    ], resolve),
                meta: {
                    title: "品名管理"
                }
            },
            {
                path: "/Home/SystemBase/ship",
                name: "船舶资料",
                component: resolve =>
                    require(["../views/business/port/ship.vue"], resolve),
                meta: {
                    title: "船舶资料"
                }
            },
            {
                path: "/Home/SystemBase/feeRule",
                name: "计费规则",
                component: resolve =>
                    require(["../views/business/balance/feeRule.vue"], resolve),
                meta: {
                    title: "计费规则"
                }
            },
            {
                path: "/Home/SystemBase/pieceRule",
                name: "计件规则",
                component: resolve =>
                    require([
                        "../views/business/balance/pieceRule.vue"
                    ], resolve),
                meta: {
                    title: "计件规则"
                }
            },
            {
                path: "/Home/SystemBase/haiGuan",
                name: "海关核销数据管理",
                component: resolve =>
                    require([
                        "../views/business/baseResource/hiGuan.vue"
                    ], resolve),
                meta: {
                    title: "海关核销数据管理"
                }
            },
            {
                path: "/Home/SystemS/Department",
                name: "部门管理",
                component: resolve =>
                    require([
                        "../views/business/system/department.vue"
                    ], resolve),
                meta: {
                    title: "部门管理"
                }
            },
            {
                path: "/Home/SystemS/excel",
                name: "excel模板",
                component: resolve =>
                    require([
                        "../views/business/base-excel/index.vue"
                    ], resolve),
                meta: {
                    title: "excel模板"
                }
            },
            {
                path: "/Home/SystemS/Role",
                name: "角色管理",
                component: resolve =>
                    require(["../views/business/system/role.vue"], resolve),
                meta: {
                    title: "角色管理"
                }
            },
            {
                path: "/Home/SystemS/Org",
                name: "使用单位",
                component: resolve =>
                    require(["../views/business/system/org.vue"], resolve),
                meta: {
                    title: "使用单位"
                }
            },
            {
                path: "/Home/SystemS/Person",
                name: "用户管理",
                component: resolve =>
                    require(["../views/business/system/person.vue"], resolve),
                meta: {
                    title: "用户管理"
                }
            },
            {
                path: "/Home/SystemS/SystemParameter",
                name: "系统参数管理",
                component: resolve =>
                    require([
                        "../views/business/system/systemParameter.vue"
                    ], resolve),
                meta: {
                    title: "系统参数管理"
                }
            },
            {
                path: "/Home/SystemS/SecurityGroup",
                name: "安全组",
                component: resolve =>
                    require([
                        "../views/business/system/securityGroup.vue"
                    ], resolve),
                meta: {
                    title: "安全组"
                }
            },
            {
                path: "/Home/InterfaceManagement",
                name: "interface-management",
                component: resolve =>
                    require([
                        "../views/business/system/interfaceManagement.vue"
                    ], resolve),
                meta: {
                    title: "接口管理"
                }
            },
            {
                path: "/Home/SystemS/SystemDictionary",
                name: "系统字典",
                component: resolve =>
                    require([
                        "../views/business/system/systemDictionary.vue"
                    ], resolve),
                meta: {
                    title: "系统字典"
                }
            },
            {
                path: "/Home/SystemS/AppInfo",
                name: "应用管理",
                component: resolve =>
                    require(["../views/business/system/appInfo.vue"], resolve),
                meta: {
                    title: "应用管理"
                }
            },
            {
                path: "/Home/SystemS/AppVersion",
                name: "应用版本管理",
                component: resolve =>
                    require([
                        "../views/business/system/appVersion.vue"
                    ], resolve),
                meta: {
                    title: "应用版本管理"
                }
            },

            //登录信息查询
            {
                path: "/Home/LoginInfo/LoginInfo",
                name: "登录信息查询",
                component: resolve =>
                    require([
                        "../views/business/LoginInfo/LoginInfo.vue"
                    ], resolve),
                meta: {
                    title: "登录信息查询"
                }
            },
            {
                path: "/Home/SystemBase/rule",
                name: "规则设置",
                component: resolve =>
                    require(["../views/business/rule/index.vue"], resolve),
                meta: {
                    title: "规则设置"
                }
            },
            {
                path: "/work/JobBase",
                name: "现场作业基础管理",
                component: resolve =>
                    require(["../views/business/jobBase/index.vue"], resolve),
                meta: {
                    title: "现场作业基础管理"
                }
            },
            {
                path: "/work/JobPlan",
                name: "铁路作业计划管理",
                component: resolve =>
                    require(["../views/business/jobPlan/index.vue"], resolve),
                meta: {
                    title: "铁路作业计划管理"
                }
            },
            {
                path: "/work/yardPlan",
                name: "堆场策划管理",
                component: resolve =>
                    require(["../views/business/yardPlan/index.vue"], resolve),
                meta: {
                    title: "堆场策划管理"
                }
            },
            {
                path: "/work/yardMsg",
                name: "堆场管理",
                component: resolve =>
                    require([
                        "../views/business/yardPlan/yardMsg.vue"
                    ], resolve),
                meta: {
                    title: "堆场管理"
                }
            },
            {
                path: "/work/yardMachine",
                name: "场区机械配置",
                component: resolve =>
                    require([
                        "../views/business/yardPlan/yardMachine.vue"
                    ], resolve),
                meta: {
                    title: "场区机械配置"
                }
            },
            {
                path: "/work/yardPlanType",
                name: "堆场策划类型",
                component: resolve =>
                    require([
                        "../views/business/yardPlan/yardPlanType.vue"
                    ], resolve),
                meta: {
                    title: "堆场策划类型"
                }
            },
            {
                path: "/work/yardMap",
                name: "堆场图",
                component: resolve =>
                    require([
                        "../views/business/yardPlan/yardMap.vue"
                    ], resolve),
                meta: {
                    title: "堆场图"
                }
            },
            {
                path: "/work/JobTable",
                name: "计划列表",
                component: resolve =>
                    require([
                        "../views/business/jobPlan/JobTable.vue"
                    ], resolve),
                meta: {
                    title: "计划列表"
                }
            },
            {
                path: "/work/gatePanel",
                name: "铁路道闸工作台",
                component: resolve =>
                    require(["../views/business/gatePanel/index.vue"], resolve),
                meta: {
                    title: "铁路道闸工作台"
                }
            },
            {
                path: "/work/portCount",
                name: "港口总览",
                component: resolve =>
                    require(["../views/business/portCount/index.vue"], resolve),
                meta: {
                    title: "港口总览"
                }
            },
            {
                path: "/work/containerJob",
                name: "铁路集装箱作业台",
                component: resolve =>
                    require([
                        "../views/business/containerJob/index.vue"
                    ], resolve),
                meta: {
                    title: "铁路集装箱作业台"
                }
            },
            {
                path: "/work/piece",
                name: "作业计件",
                component: resolve =>
                    require(["../views/business/piece/index.vue"], resolve),
                meta: {
                    title: "作业计件"
                }
            },
            {
                path: "/work/team",
                name: "班组统计",
                component: resolve =>
                    require(["../views/business/piece/team.vue"], resolve),
                meta: {
                    title: "班组统计"
                }
            },
            {
                path: "/work/teamDetail",
                name: "作业明细",
                component: resolve =>
                    require(["../views/business/piece/detail.vue"], resolve),
                meta: {
                    title: "作业明细"
                }
            },
            {
                path: "/work/containerJob/workList",
                name: "作业列表",
                component: resolve =>
                    require(["../views/business/workList/index.vue"], resolve),
                meta: {
                    title: "作业列表"
                }
            },
            {
                path: "/work/middleControl",
                name: "中控调度",
                component: resolve =>
                    require([
                        "../views/business/middleControl/index.vue"
                    ], resolve),
                meta: {
                    title: "中控调度"
                }
            },
            {
                path: "/work/badBox",
                name: "坏箱登记",
                component: resolve =>
                    require([
                        "../views/business/middleControl/badBox.vue"
                    ], resolve),
                meta: {
                    title: "坏箱登记"
                }
            },
            {
                path: "/work/gate",
                name: "闸口管理",
                component: resolve =>
                    require(["../views/business/gate/index.vue"], resolve),
                meta: {
                    title: "闸口管理"
                }
            },
            {
                path: "/work/shipPlan/index",
                name: "理货作业",
                component: resolve =>
                    require(["../views/business/shipPlan/index.vue"], resolve),
                meta: {
                    title: "理货作业"
                }
            },
            {
                path: '/work/shipPlan/dayReport',
                name: '理货作业日报',
                component: resolve => require(['../views/business/shipPlan/dayReport.vue'], resolve),
                meta: {
                    title: '理货作业日报'
                }
            },
            {
                path: '/work/shipPlan/monthReport',
                name: '财务月报',
                component: resolve => require(['../views/business/shipPlan/monthReport.vue'], resolve),
                meta: {
                    title: '财务月报'
                }
            },
            {
                path: '/work/shipPlan/monthAccFeeReport',
                name: '月度结算统计',
                component: resolve => require(['../views/business/shipPlan/monthAccFeeReport.vue'], resolve),
                meta: {
                    title: '月度结算统计'
                }
            },
            {
                path: '/work/shipPlan/productReport',
                name: '生产作业统计',
                component: resolve => require(['../views/business/shipPlan/productReport.vue'], resolve),
                meta: {
                    title: '生产作业统计'
                }
            },
            {
                path: '/work/shipPlan/load',
                name: '装船计划列表',
                component: resolve => require(['../views/business/shipPlan/shipLoad.vue'], resolve),
                meta: {
                    title: '装船计划列表'
                }
            },
            {
                path: "/work/shipPlan/loadAdd",
                name: "创建装船计划",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/shipLoadAdd.vue"
                    ], resolve),
                meta: {
                    title: "创建装船计划"
                }
            },
            {
                path: "/work/shipPlan/loadEdit",
                name: "编辑装船计划",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/shipLoadEdit.vue"
                    ], resolve),
                meta: {
                    title: "编辑装船计划"
                }
            },
            {
                path: "/work/shipPlan/close",
                name: "外理封航",
                component: resolve =>
                    require(["../views/business/shipPlan/close.vue"], resolve),
                meta: {
                    title: "外理封航"
                }
            },
            {
                path: "/work/shipPlan/unload",
                name: "卸船计划列表",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/shipUnload.vue"
                    ], resolve),
                meta: {
                    title: "卸船计划列表"
                }
            },
            {
                path: "/work/shipPlan/shipUnloadZgyl",
                name: "补录转关单号",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/shipUnloadZgyl.vue"
                    ], resolve),
                meta: {
                    title: "补录转关单号"
                }
            },
            {
                path: "/work/shipPlan/unloadAdd",
                name: "创建卸船计划",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/shipUnloadAdd.vue"
                    ], resolve),
                meta: {
                    title: "创建卸船计划"
                }
            },
            {
                path: "/work/shipPlan/unloadEdit",
                name: "编辑卸船计划",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/shipUnloadEdit.vue"
                    ], resolve),
                meta: {
                    title: "编辑卸船计划"
                }
            },
            {
                path: "/work/shipPlan/feeForm",
                name: "拆提放行",
                component: resolve =>
                    require(["../views/business/shipPlan/feeForm.vue"], resolve),
                meta: {
                    title: "拆提放行"
                }
            },{
                path: "/work/shipPlan/fee",
                name: "拆提封航",
                component: resolve =>
                    require(["../views/business/shipPlan/fee.vue"], resolve),
                meta: {
                    title: "拆提封航"
                }
            },{
                path: '/work/query/load',
                name: '装船查询',
                component: resolve => require(['../views/business/query/load.vue'], resolve),
                meta: {
                    title: '装船查询'
                }
            },
            {
                path: '/work/query/loadDetail',
                name: '装船计划详情',
                component: resolve => require(['../views/business/query/loadDetail.vue'], resolve),
                meta: {
                    title: '装船计划详情'
                }
            },
            {
                path: '/work/query/unload',
                name: '卸船查询',
                component: resolve => require(['../views/business/query/unload.vue'], resolve),
                meta: {
                    title: '卸船查询'
                }
            },
            {
                path: '/work/query/unloadDetail',
                name: '卸船计划详情',
                component: resolve => require(['../views/business/query/unloadDetail.vue'], resolve),
                meta: {
                    title: '卸船计划详情'
                }
            },
            {
                path: '/work/query/damaged',
                name: '残损箱查询',
                component: resolve => require(['../views/business/query/damaged.vue'], resolve),
                meta: {
                    title: '残损箱查询'
                }
            },
            {
                path: '/work/query/bill',
                name: '账单查询',
                component: resolve => require(['../views/business/query/bill.vue'], resolve),
                meta: {
                    title: '账单查询'
                }
            },
            {
                path: '/work/query/special',
                name: '特殊理箱查询',
                component: resolve => require(['../views/business/query/special.vue'], resolve),
                meta: {
                    title: '特殊理箱查询'
                }
            },
            {
                path: '/work/shipPlan/jobTrack',
                name: '作业跟踪',
                component: resolve => require(['../views/business/shipPlan/jobTrack.vue'], resolve),
                meta: {
                    title: '作业跟踪'
                }
            },
            {
                path: '/work/query/unpack',
                name: '拆箱查询',
                component: resolve => require(['../views/business/query/unpacking.vue'], resolve),
                meta: {
                    title: '拆箱查询'
                }
            },
            {
                path: '/work/query/boxup',
                name: '装箱查询',
                component: resolve => require(['../views/business/query/boxup.vue'], resolve),
                meta: {
                    title: '装箱查询'
                }
            },
            {
                path: '/work/shipPlan/report',
                name: '装船理箱报告',
                component: resolve => require(['../views/business/shipPlan/report.vue'], resolve),
                meta: {
                    title: '装船理箱报告'
                }
            },
            {
                path: '/work/shipPlan/stowageMap/:shipName/:voayge',
                name: '装船理箱报告',
                component: resolve => require(['../views/business/shipPlan/stowageMap.vue'], resolve),
                meta: {
                    title: '装船理箱报告'
                }
            },
            {
                path: '/work/shipPlan/reportDemo',
                name: '装船理箱报告',
                component: resolve => require(['../views/business/shipPlan/report.vue'], resolve),
                meta: {
                    title: '装船理箱报告'
                }
            },
            {
                path: "/work/query/loadDetail",
                name: "装船计划详情",
                component: resolve =>
                    require([
                        "../views/business/query/loadDetail.vue"
                    ], resolve),
                meta: {
                    title: "装船计划详情"
                }
            },
            {
                path: "/work/query/unload",
                name: "卸船查询",
                component: resolve =>
                    require(["../views/business/query/unload.vue"], resolve),
                meta: {
                    title: "卸船查询"
                }
            },
            {
                path: "/work/query/unloadDetail",
                name: "卸船计划详情",
                component: resolve =>
                    require([
                        "../views/business/query/unloadDetail.vue"
                    ], resolve),
                meta: {
                    title: "卸船计划详情"
                }
            },
            {
                path: "/work/shipPlan/report",
                name: "装船理箱报告",
                component: resolve =>
                    require(["../views/business/shipPlan/report.vue"], resolve),
                meta: {
                    title: "装船理箱报告"
                }
            },
            {
                path: "/work/shipPlan/unReport",
                name: "卸船理箱报告",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/unReport.vue"
                    ], resolve),
                meta: {
                    title: "卸船理箱报告"
                }
            },
            {
                path: "/work/feeClose",
                name: "拆提放行",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/feeClose.vue"
                    ], resolve),
                meta: {
                    title: "拆提放行"
                }
            },
            {
                path: "/work/load",
                name: "装箱理货",
                component: resolve =>
                    require(["../views/business/shipPlan/load.vue"], resolve),
                meta: {
                    title: "装箱理货"
                }
            },
            {
                path: "/work/unbox",
                name: "拆箱理货",
                component: resolve =>
                    require(["../views/business/shipPlan/unbox.vue"], resolve),
                meta: {
                    title: "拆箱理货"
                }
            },
            {
                path: "/work/special",
                name: "特殊理箱",
                component: resolve =>
                    require([
                        "../views/business/shipPlan/special.vue"
                    ], resolve),
                meta: {
                    title: "特殊理箱"
                }
            },
            {
                path: "/work/balance",
                name: "结算对账单",
                component: resolve =>
                    require(["../views/business/balance/balance.vue"], resolve),
                meta: {
                    title: "结算对账单"
                }
            },
            {
                path: "/work/proofreadBill",
                name: "月对账单",
                component: resolve =>
                    require(["../views/business/balance/proofreadBill.vue"], resolve),
                meta: {
                    title: "月对账单"
                }
            },
			{
			    path: "/work/billDetail",
			    name: "对账单明细",
			    component: resolve =>
			        require(["../views/business/balance/billDetail.vue"], resolve),
			    meta: {
			        title: "对账单明细"
			    }
			},
            {
                path: "/work/balanceDetail",
                name: "对账单查看",
                component: resolve =>
                    require(["../views/business/balance/detail.vue"], resolve),
                meta: {
                    title: "对账单查看"
                }
            },
            {
                path: "/work/cash",
                name: "现结查询",
                component: resolve =>
                    require(["../views/business/balance/cash.vue"], resolve),
                meta: {
                    title: "现结查询"
                }
            },
            {
                path: "/work/task",
                name: "作业计件",
                component: resolve =>
                    require(["../views/business/balance/task.vue"], resolve),
                meta: {
                    title: "作业计件"
                }
            },
            {
                path: "/work/classCount",
                name: "港口日期班组统计",
                component: resolve =>
                    require([
                        "../views/business/balance/classCount.vue"
                    ], resolve),
                meta: {
                    title: "港口日期班组统计"
                }
            },
            {
                path: "/work/workClass",
                name: "作业班组统计",
                component: resolve =>
                    require([
                        "../views/business/balance/workClass.vue"
                    ], resolve),
                meta: {
                    title: "作业班组统计"
                }
            },
            {
                path: "/work/workPerson",
                name: "作业人员统计",
                component: resolve =>
                    require([
                        "../views/business/balance/workPerson.vue"
                    ], resolve),
                meta: {
                    title: "作业人员统计"
                }
            },
            {
                path: "/work/cashIndex",
                name: "财务结算",
                component: resolve =>
                    require([
                        "../views/business/balance/feeIndex.vue"
                    ], resolve),
                meta: {
                    title: "财务结算"
                }
            },
            {
                path: "/work/messageQuery",
                name: "报文查询",
                component: resolve =>
                    require(["../views/business/messageQuery/messageQuery.vue"], resolve),
                meta: {
                    title: "报文查询"
                }
            },
            {
                path: "/work/messageQuery/detail",
                name: "报文明细",
                component: resolve =>
                    require(["../views/business/messageQuery/messageQueryDetail.vue"], resolve),
                meta: {
                    title: "报文明细"
                }
            }
        ]
    },
    {
        path: "/business/busPla/Project",
        name: "Project",
        component: layout,
        meta: {
            title: "Project"
        },
        redirect: "/business/busPla/Project/index",
        children: [
            {
                path: "index",
                name: "项目管理",
                component: resolve =>
                    require(["../views/business/project/index.vue"], resolve),
                meta: {
                    title: "项目管理"
                }
            },
            {
                path: "build/:model/:id",
                name: "项目操作",
                component: resolve =>
                    require(["../views/business/project/step.vue"], resolve),
                meta: {
                    title: "项目操作"
                }
            }
        ]
    },
    {
        path: '/Login',
        name: 'login',
        component: resolve => require(['../views/login/wlLogin.vue'], resolve),
        //component: resolve => require(['../views/login/Login.vue'], resolve),
        meta: {
            title: "登录"
        }
    },
    {
        path: "/Preview",
        name: "preview",
        component: resolve =>
            require(["../views/business/common/preview.vue"], resolve),
        meta: {
            title: "预览"
        }
    },
    {
        path: "/TicketPrint",
        name: "ticketPrint",
        component: resolve =>
            require(["../views/business/gate/print.vue"], resolve),
        meta: {
            title: "打印小票"
        }
    },
    {
        path: "/UnboxPrint/:id",
        name: "UnboxPrint",
        component: resolve =>
            require(["../views/business/print/unboxPrint.vue"], resolve),
        meta: {
            title: "货损报告打印"
        }
    },
    {
        path: "/TotalPrint/:id",
        name: "TotalPrint",
        component: resolve =>
            require(["../views/business/print/totalPrint.vue"], resolve),
        meta: {
            title: "汇总报告套印"
        }
    },
    {
        path: "/newTotalPrint/:id",
        name: "newTotalPrint",
        component: resolve =>
            require(["../views/business/print/newTotalPrint.vue"], resolve),
        meta: {
            title: "汇总报告打印"
        }
    },
    {
        path: "/newDetailPrint/:id",
        name: "newTotalPrint",
        component: resolve =>
            require(["../views/business/print/newDetailPrint.vue"], resolve),
        meta: {
            title: "明细报告打印"
        }
    },
    {
        path: "/DetailPrint/:id",
        name: "DetailPrint",
        component: resolve =>
            require(["../views/business/print/detailPrint.vue"], resolve),
        meta: {
            title: "明细报告打印"
        }
    },
    {
        path: "/DamagePrint/:id",
        name: "DamagePrint",
        component: resolve =>
            require(["../views/business/print/damagePrint.vue"], resolve),
        meta: {
            title: "货损报告套印"
        }
    },
    {
        path: "/DamagePrintNew/:id",
        name: "DamagePrintNew",
        component: resolve =>
            require(["../views/business/print/damagePrintNew.vue"], resolve),
        meta: {
            title: "货损报告打印"
        }
    },
    {
        path: "/newAllIdPrint/:id",
        name: "newAllIdPrint",
        component: resolve =>
            require(["../views/business/print/newAllIdPrint.vue"], resolve),
        meta: {
            title: "一键打印所有单证"
        }
    },
    {
        path: "/OnPortPrint/:id",
        name: "onPortPrint",
        component: resolve =>
            require(["../views/business/print/onPortPrint.vue"], resolve),
        meta: {
            title: "港装箱报告打印"
        }
    },
    {
        path: "/Total/:id",
        name: "Total",
        component: resolve =>
            require(["../views/business/print/total.vue"], resolve),
        meta: {
            title: "汇总账单打印"
        }
    },
    {
        path: "/sendCarPrint",
        name: "Departure-car-print",
        component: resolve =>
            require([
                "../views/business/print/Departure-car-print.vue"
            ], resolve),
        meta: {
            title: "发车车皮打印"
        }
    },
    {
        path: "/Balance/:id",
        name: "Balance",
        component: resolve =>
            require(["../views/business/print/balance.vue"], resolve),
        meta: {
            title: "结算账单"
        }
    },
    {
        path: "/Balance2/:id",
        name: "Balance",
        component: resolve =>
            require(["../views/business/print/balance2.vue"], resolve),
        meta: {
            title: "结算账单"
        }
    },
    {
        path: "/BalanceNew/:id",
        name: "Balance",
        component: resolve =>
            require(["../views/business/print/balanceNew.vue"], resolve),
        meta: {
            title: "结算账单"
        }
    },
    {
        path: "/BalanceNew2/:id",
        name: "Balance",
        component: resolve =>
            require(["../views/business/print/balanceNew2.vue"], resolve),
        meta: {
            title: "结算账单"
        }
    },
    {
        path: "/Detail/:id",
        name: "Detail",
        component: resolve =>
            require(["../views/business/print/detail.vue"], resolve),
        meta: {
            title: "明细打印"
        }
    },
    {
        path: "/shipDetail/:id/:planNo",
        name: "shipDetail",
        component: resolve =>
            require(["../views/business/print/shipDetail.vue"], resolve),
        meta: {
            title: "装卸船明细打印"
        }
    },
    {
        path: "/Sp",
        name: "Sp",
        component: resolve =>
            require(["../views/business/print/sp.vue"], resolve),
        meta: {
            title: "特殊理箱明细打印"
        }
    },
    {
        path: "/stowage/:id",
        name: "stowage",
        component: resolve =>
            require(["../views/business/print/stowage.vue"], resolve),
        meta: {
            title: "积载图打印"
        }
    },
    {
        path: "/bayPrint/:id",
        name: "bayPrint",
        component: resolve =>
            require(["../views/business/print/bayPrint.vue"], resolve),
        meta: {
            title: "贝位图打印"
        }
    },
    {
        path: "/monthRep",
        name: "monthRep",
        component: resolve =>
            require(["../views/business/print/month.vue"], resolve),
        meta: {
            title: "月报总表打印"
        }
    },
    {
        path: "/monthTotal",
        name: "monthTotal",
        component: resolve =>
            require(["../views/business/print/monthTotal.vue"], resolve),
        meta: {
            title: "月结账单打印"
        }
    },
    {
        path: "/monthShipName",
        name: "monthShipName",
        component : resolve =>
            require(["../views/business/print/monthShipName.vue"], resolve),
        meta: {
            title: "船代统计打印"
        }
    },
    {
        path: "/monthAccFee",
        name: "monthAccFee",
        component : resolve =>
            require(["../views/business/print/monthAccFee.vue"], resolve),
        meta: {
            title: "月度结算统计表"
        }
    },
    {
        path: "/productCdName",
        name: "productCdName",
        component : resolve =>
            require(["../views/business/print/productCdName.vue"], resolve),
        meta: {
            title: "生产船代统计打印"
        }
    },
    {
        path: "/productShipName",
        name: "productShipName",
        component : resolve =>
            require(["../views/business/print/productShipName.vue"], resolve),
        meta: {
            title: "生产进度统计打印"
        }
    },
    {
        path: "/productCountPrint",
        name: "productCountPrint",
        component : resolve =>
            require(["../views/business/print/productCountPrint.vue"], resolve),
        meta: {
            title: "生产月统计报表打印"
        }
    },
    {
        path: "/Chain",
        name: "Chain",
        component: resolve =>
            require(["../views/business/print/Chain.vue"], resolve),
        meta: {
            title: "月报同比表打印"
        }
    },
    {
        path: "/YOY",
        name: "YOY",
        component: resolve =>
            require(["../views/business/print/YOY.vue"], resolve),
        meta: {
            title: "月报环比表打印"
        }
    },{
        path: "/ShipPlanPrint",
        name: "ShipPlanPrint",
        component : resolve =>
            require(["../views/business/print/ShipPlanPrint.vue"], resolve),
        meta: {
            title: "理箱列表打印"
        }
    },{
        path: "/loadPlanPrint",
        name: "loadPlanPrint",
        component : resolve =>
            require(["../views/business/print/loadPlanPrint.vue"], resolve),
        meta: {
            title: "理箱列表打印"
        }
    },

    //外理新增内容
    {
        path: "/tllxjhPrint",
        name: "铁路理箱计划打印",
        component: resolve =>
            require(["../views/LiHuoZuoYe/TLLXJHPrint.vue"], resolve),
        meta: {
            title: "铁路理箱计划打印"
        }
    },
    
    {
        path: "/cs_pdf",
        name: "打印残损PDF",
        component: resolve =>
            require(["../views/LiHuoZuoYe/CS_PDF.vue"], resolve),
        meta: {
            title: "打印残损PDF"
        }
    },

    {
        path: "/printTLXTJ",
        name: "打印铁路箱报表",
        component: resolve =>
            require(["../views/LiHuoZuoYe/cmps/printTLXTJ.vue"], resolve),
        meta: {
            title: "打印铁路箱报表"
        }
    },
    {
        path: "/printTBHB",
        name: "打印铁路箱同比环比增长表",
        component: resolve =>
            require(["../views/LiHuoZuoYe/cmps/printTBHB.vue"], resolve),
        meta: {
            title: "打印铁路箱同比环比增长表"
        }
    },
    {
        path: "/printBangDan",
        name: "火车装车作业榜单",
        component: resolve =>
            require(["../views/LiHuoZuoYe/cmps/printBangDan.vue"], resolve),
        meta: {
            title: "火车装车作业榜单"
        }
    },    
    {
        path: "/LiHuoZuoYe",
        name: "LiHuoZuoYe",
        component: layout,
        meta: {
            title: "LiHuoZuoYe"
        },
        redirect: "/work/shipPlan/index",
        children: [
            {
                path: "tllxjh",
                name: "铁路理箱计划",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLLXJH.vue"], resolve),
                meta: {
                    title: "铁路理箱计划"
                }
            },
            {
                path: "tllxjhEdit",
                name: "铁路理箱计划编辑",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLLXJHEdit.vue"], resolve),
                meta: {
                    title: "铁路理箱计划编辑"
                }
            },
            {
                path: "tllxjhDetail",
                name: "铁路理箱计划详情",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLLXJHDetail.vue"], resolve),
                meta: {
                    title: "铁路理箱计划详情"
                }
            },

            {
                path: "xc",
                name: "卸车",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/XC.vue"], resolve),
                meta: {
                    title: "卸车"
                }
            },
            // {
            //     path: "xc_WZY",
            //     name: "理箱未作业",
            //     component: resolve =>
            //         require(["../views/LiHuoZuoYe/XC_WZY.vue"], resolve),
            //     meta: {
            //         title: "理箱未作业"
            //     }
            // },
            {
                path: "xc_WZY",
                name: "理箱未作业",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/XC.vue"], resolve),
                meta: {
                    title: "理箱未作业"
                }
            },
            {
                path: "xc_ZYZ",
                name: "理箱作业中",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/XC.vue"], resolve),
                meta: {
                    title: "理箱作业中"
                }
            },
            {
                path: "xc_YXC",
                name: "已卸车",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/XC.vue"], resolve),
                meta: {
                    title: "已卸车"
                }
            },
            {
                path: "xc_YLX",
                name: "已理箱",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/XC.vue"], resolve),
                meta: {
                    title: "已理箱"
                }
            },

            {
                path: "tlzcjh",
                name: "铁路装车计划",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLZCJH.vue"], resolve),
                meta: {
                    title: "铁路装车计划"
                }
            },
            {
                path: "tlzcjhEdit",
                name: "铁路装车计划编辑",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLZCJHEdit.vue"], resolve),
                meta: {
                    title: "铁路装车计划编辑"
                }
            },
            {
                path: "tlzcjhDetail",
                name: "铁路装车计划详情",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLZCJHDetail.vue"], resolve),
                meta: {
                    title: "铁路装车计划详情"
                }
            },
            {
                path: "fc",
                name: "发车",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FC.vue"], resolve),
                meta: {
                    title: "发车"
                }
            },
            {
                path: "fc_NOTWORK",
                name: "待装车",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FC.vue"], resolve),
                meta: {
                    title: "待装车"
                }
            },
            {
                path: "fc_LOADED",
                name: "已装车",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FC.vue"], resolve),
                meta: {
                    title: "已装车"
                }
            },
            {
                path: "fc_SENDED",
                name: "已发车",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FC.vue"], resolve),
                meta: {
                    title: "已发车"
                }
            },
            {
                path: "fcsh",
                name: "发车审核量",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FCSH.vue"], resolve),
                meta: {
                    title: "发车审核量"
                }
            },
            {
                path: "fcshl",//FCSHL
                name: "理箱审核量",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FCSHL.vue"], resolve),
                meta: {
                    title: "理箱审核量"
                }
            },
            {
                path: "fcshmx",
                name: "发车审核明细",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/FCSHMX.vue"], resolve),
                meta: {
                    title: "发车审核明细"
                }
            },
            {
                path: "tlzygz",
                name: "铁路作业.跟踪",
                component: resolve =>
                    require(["../views/LiHuoZuoYe/TLZYGZ.vue"], resolve),
                meta: {
                    title: "铁路作业.跟踪"
                }
            },
            // {
            //     path: "cs_pdf",
            //     name: "打印残损PDF",
            //     component: resolve =>
            //         require(["../views/LiHuoZuoYe/CS_PDF.vue"], resolve),
            //     meta: {
            //         title: "打印残损PDF"
            //     }
            // },
        ]
    },
    //外理新增内容 - End
    
    {
        path: "/ZCX_XSZF",
        name: "装拆箱线上支付",
        component: resolve =>
            require(["../views/special/ZCX_XSZF.vue"], resolve),
        meta: {
            title: "装拆箱线上支付"
        }
    },

];

const router = new Router({
    routes
});

router.afterEach(to => {
    document.title = (to.meta && to.meta.title) || "万州集装箱系统";
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js